import "./style.css";
import { SceneTrainingApp } from "./app/SceneTrainingApp";
import { isProgrammaticSceneId, StimulusScenePrototype } from "./prototype/StimulusScenePrototype";
import { WoodLivingRoomPrototype } from "./prototype/WoodLivingRoomPrototype";

const app = document.querySelector<HTMLElement>("#app");

if (!app) {
  throw new Error("Missing #app mount point");
}

const prototypeId = new URLSearchParams(location.search).get("prototype");

if (prototypeId === "wood-living-room") {
  new WoodLivingRoomPrototype(app);
} else if (isProgrammaticSceneId(prototypeId)) {
  new StimulusScenePrototype(app, prototypeId);
} else {
  new SceneTrainingApp(app);
}
